import { View } from "./View";

interface ICheckoutPaymentpage{
  rightcontent: string;
 leftcontent: string;
 
 
}

export const CheckoutPaymentpage = (
  props: ICheckoutPaymentpage
) => {
  return <View {...props}  />;
};
